import {TextField} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTranslate } from "react-redux-multilingual";

const otpverify = ({ formik,  emailId }) => {
    const t = useTranslate();
    const matches = useMediaQuery('(min-width:500px)');

    const style = {
        otpcontainer:{ padding: "2em 4em 2em 3em", marginTop: '-0.5rem' },
        otpmain:{ display: 'flex', justifyContent: 'center', padding: "1em" },
        otptextfield:{ margin: '7px', width: `${matches ? '33rem' : '16rem'}` },
        emailotp:{ display: 'flex', justifyContent: 'center' },
        otpfield:{ margin: '7px', width: `${matches ? '33rem' : '16rem'}` }
    }
    return (
        <>
            <div style={style.otpcontainer}>
                <div style={style.otpmain}>
                    {/* Email for otp */}
                    <TextField
                        sx={style.otptextfield}
                        id="email"
                        name="email"
                        label={t('emailAddress')}
                        required
                        value={emailId}
                        onChange={formik.handleChange}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                        inputProps={{ maxLength: 150 }}
                        InputLabelProps={{
                            sx: {
                                '& .MuiFormLabel-asterisk': {
                                    color: 'red',
                                },
                            },
                            '&.MuiInputLabel-shrink': {
                                fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                              },
                              transition: 'all 0.2s ease', // Make it a bit bigger when focused
                            
                        }}
                    />
                </div>
                <div style={style.emailotp}>
                    {/* OTP */}
                    <TextField
                        sx={style.otpfield}
                        id="otp" 
                        name="otp"
                        label={t('enterotp')}
                        required
                        value={formik.values.otp}
                        onChange={formik.handleChange}
                        error={formik.touched.otp && Boolean(formik.errors.otp)}
                        helperText={formik.touched.otp && formik.errors.otp}
                        inputProps={{ maxLength: 150 }}
                        InputLabelProps={{
                            sx: {
                                '& .MuiFormLabel-asterisk': {
                                    color: 'red',
                                },
                            },
                            '&.MuiInputLabel-shrink': {
                                fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                              },
                              transition: 'all 0.2s ease', // Make it a bit bigger when focused
                            
                        }}
                    />
                </div>
            </div>
        </>
    )
}

export default otpverify;